import { QueryParams } from '../../../api';

export const convertToQueryParams = (obj: object) => {
    return Object.entries(obj).reduce<QueryParams>(
        (queryParams, [paramKey, paramValue]) => ({
            ...queryParams,
            ...(paramValue !== undefined && {
                [paramKey]: paramValue.toString()
            })
        }),
        {}
    );
};
